var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.semesterItems,"label":"Semester","dense":"","outlined":"","hide-details":"","return-object":"","color":"#ec9436"},model:{value:(_vm.semester),callback:function ($$v) {_vm.semester=$$v},expression:"semester"}})
}
var staticRenderFns = []

export { render, staticRenderFns }